import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';

@Injectable({ providedIn: 'root' })
export default class LanguageService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	
	getLanguageRatings() {
		return this.httpClient.get(this.config.getRestUrl() + '/publicrest/language-rating');
	}
	
	getAvailableLanguages() {
		return this.httpClient.get(this.config.getRestUrl() + '/publicrest/language-rating/available-languages');
	}
	
	incrementLanguageUsageRating(languageCode) {
		return this.httpClient.get(this.config.getRestUrl() + '/publicrest/language-rating/' + languageCode + '/increment');
	}
	
}